import { createFileRoute } from '@tanstack/react-router';
import { renderToString } from 'react-dom/server';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import documentation from '../documentation/aktionen.md?raw';

export const Route = createFileRoute('/documentation')({
    component: () => (
        <main>
            <iframe
                allow=""
                height="100%"
                referrerPolicy="no-referrer"
                sandbox="allow-popups"
                srcDoc={renderToString(
                    <html lang="de">
                        <head>
                            <title>Dokumentation</title>
                            <style>{'body {margin: 0}'}</style>
                            <base target="_blank" />
                        </head>

                        <body>
                            {/*<FluentProvider theme={webLightTheme}>
                                    <ReactMarkdown>
                                        {documentation}
                                    </ReactMarkdown>
                                </FluentProvider>*/}
                            <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                                {documentation}
                            </ReactMarkdown>
                        </body>
                    </html>
                )}
                style={{ border: 'none' }}
                title="Dokumentation"
                width="100%"
            />
        </main>
    ),
});
